var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
export var EditorComponentContainer = React.memo(function (props) {
    return (React.createElement("div", { className: "saucer-editor-component-container", style: __assign({ padding: 8, display: 'flex', alignItems: 'center' }, props.style) },
        React.createElement("div", null,
            props.label,
            ":\u00A0"),
        React.createElement("div", { style: { flex: 1 } }, props.children)));
});
EditorComponentContainer.displayName = 'EditorComponentContainer';
